import React from "react";

const NfcEnabled = () => {
  return (
    <div className="bg-[#F5F0FA] p-6 w-full mb-10 md:px-20 px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-start">
        <div className="col-span-12 md:col-span-4 flex items-center md:items-start">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#118B91]">
            NFC Technology 
            <br></br>
            Enabled
          </h2>
        </div>
        <div className="space-y-4 mt-4 mb-4 col-span-12 md:col-span-4 text-base md:text-lg leading-7">
          <span>
            <b>NFC (Near-Field Communication)</b> is a simple, safe technology that works when two devices are held close together. <b>It's fast, secure, and doesn't need any apps. With just one tap, your medical emergency card can instantly share important health details with responders</b> — helping them know exactly how to support you.</span>
          <br></br>
          <br></br>
          This means people with chronic illnesses, invisible or visible disabilities can move through daily life and travel with more confidence, dignity, and safety.
        </div>
        <div className="col-span-12 md:col-span-4 flex justify-center md:justify-end">
          <img
            src={process.env.PUBLIC_URL + "/Assets/Images/NFCCard.svg"}
            alt="NFC Card Demo"
            className="w-full max-w-[320px] md:max-w-[500px] h-auto mx-auto"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default NfcEnabled;
